(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../core"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../core"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.core);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _react, _core) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getGridCore = _exports.Consumer = _exports.Provider = void 0;
  _react = _interopRequireDefault(_react);
  _core = _interopRequireDefault(_core);

  var getGridCore = function getGridCore() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var core = new _core.default(props);
    return core;
  }; // 初始化事件总线


  _exports.getGridCore = getGridCore;

  var getDataGridContext = function getDataGridContext() {
    var core = getGridCore();
    return {
      core: core
    };
  };

  var _React$createContext = _react.default.createContext(getDataGridContext()),
      Provider = _React$createContext.Provider,
      Consumer = _React$createContext.Consumer;

  _exports.Consumer = Consumer;
  _exports.Provider = Provider;
});